module.exports = __webpack_public_path__ + "static/media/Atv_Turchia.d4457ddc.png";